import React from 'react'
import { Label, ShowData, GridData } from './style'
import { CertificateObject } from '../../../../contexts/CertificatesContext'

interface propsType {
  certificate:CertificateObject
}

const SimpleData:React.FC<propsType> = (props) => {
  const { certificate } = props
  
  return(
    <GridData>
      <li>
        <Label>Nº do Certificado 
          <Label className='english'>(Certificate number)</Label>
        : </Label>
        <ShowData>{certificate.id}</ShowData>
      </li>
      <li>
        <Label>Cliente
          <Label className='english'>(Customer)</Label>
        : </Label>
        <ShowData>{certificate.customerCompany.companyName}</ShowData>
      </li>
      <li>
        <Label>Descrição
          <Label className='english'>(Description)</Label>
        : </Label>
        <ShowData>{certificate.description}</ShowData>
      </li>
      <li>
        <Label>Material
          <Label className='english'>(Material)</Label>
        : </Label>
        <ShowData>{certificate.material}</ShowData>
      </li>
      <li>
        <Label>Nº da Corrida
          <Label className='english'>(Run number)</Label>
        : </Label>
        <ShowData>{certificate.heatNumber.heatNumber}</ShowData>
      </li>
      <li>
        <Label>Data
          <Label className='english'>(Date)</Label>
        : </Label>
        <ShowData>
          {new Date(certificate.date).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })}
        </ShowData>
      </li>
    </GridData>
  )
}

export default SimpleData